import React from 'react';
import { Button, type ButtonProps } from 'antd';

interface AuthButtonProps extends Omit<ButtonProps, 'loading'> {
  loading?: boolean;
  loadingText?: string;
}

// Spinning circle used inside auth buttons and links while waiting for an API response
export const AuthSpinner: React.FC = () => (
  <span className="auth-spinner" role="status" aria-label="Loading" />
);

// Primary button for the sign-in / sign-up / forgot-password cards.
// While loading it shows a spinning circle with `loadingText` and ignores clicks.
const AuthButton: React.FC<AuthButtonProps> = ({
  loading = false,
  loadingText,
  className,
  children,
  ...rest
}) => (
  <Button
    {...rest}
    className={`signin__button${loading ? ' is-loading' : ''}${
      className !== undefined ? ` ${className}` : ''
    }`}
    aria-busy={loading}
  >
    {loading ? (
      <>
        <AuthSpinner />
        <span>{loadingText ?? 'Please wait...'}</span>
      </>
    ) : (
      children
    )}
  </Button>
);

export default AuthButton;
